import { render, staticRenderFns } from "./myFooter.vue?vue&type=template&id=1d2f867e&scoped=true&"
import script from "./myFooter.vue?vue&type=script&lang=ts&"
export * from "./myFooter.vue?vue&type=script&lang=ts&"
import style0 from "./myFooter.vue?vue&type=style&index=0&id=1d2f867e&scoped=true&lang=css&"
import style1 from "./myFooter.vue?vue&type=style&index=1&id=1d2f867e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2f867e",
  null
  
)

export default component.exports